import { Input, InputField } from 'aos-ui-universal'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskFormField } from '../TaskFormField'

interface TaskTitleFieldProps {
    isTaskTemplate: boolean
}

export const TaskTitleField = ({ isTaskTemplate }: TaskTitleFieldProps) => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()

    return (
        <Controller
            control={control}
            name='title'
            render={({ field, fieldState }) => (
                <TaskFormField
                    label={translate('form.title.label', { ns: 'tasks' })}
                    required={!isTaskTemplate}
                    error={
                        fieldState.error
                            ? translate('form.title.error', { ns: 'tasks' })
                            : undefined
                    }
                >
                    <Input>
                        <InputField
                            value={field.value || ''}
                            onChangeText={(v: string) => field.onChange(v)}
                        />
                    </Input>
                </TaskFormField>
            )}
        />
    )
}
